import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    BuildingView,
    CompanyBuildingViewPaginatedResultDto,
    CompanyClient,
    CompanyMapResult,
    CompanyView,
    CompanyViewPaginatedResultDto,
    QuickSearchCompaniesParameters,
    SaveAccountParameters,
    SearchAvailableAccountCompaniesParameters,
    SearchAvailableCompanyBuildingsParameters,
    SearchCompaniesForAccountParameters,
    SearchCompaniesForBuildingParameters,
    SearchCompaniesMapParameters,
    SearchCompaniesParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {
    constructor(private readonly client: CompanyClient) {}

    async save(body: CompanyView): Promise<CompanyView> {
        return await lastValueFrom(this.client.companySave(body));
    }

    async getById(id: number): Promise<CompanyView> {
        return await lastValueFrom(this.client.companyGetById(id));
    }

    async searchForBuilding(
        body: SearchCompaniesForBuildingParameters
    ): Promise<CompanyBuildingViewPaginatedResultDto> {
        return await lastValueFrom(this.client.companySearchCompaniesForBuilding(body));
    }

    async searchForAccount(body: SearchCompaniesForAccountParameters): Promise<CompanyViewPaginatedResultDto> {
        return await lastValueFrom(this.client.companySearchCompaniesForAccount(body));
    }

    async searchCompanies(body: SearchCompaniesParameters | undefined): Promise<CompanyViewPaginatedResultDto> {
        return await lastValueFrom(this.client.companySearch(body));
    }

    async search(body: QuickSearchCompaniesParameters | undefined): Promise<CompanyView[]> {
        return await lastValueFrom(this.client.companyQuickSearch(body));
    }

    async searchMap(body: SearchCompaniesMapParameters): Promise<CompanyMapResult[]> {
        return await lastValueFrom(this.client.companyMapSearch(body));
    }

    async searchAvailableBuildings(body: SearchAvailableCompanyBuildingsParameters): Promise<BuildingView[]> {
        return await lastValueFrom(this.client.companySearchAvailableBuildings(body));
    }

    async activate(id: number): Promise<void> {
        return await lastValueFrom(this.client.companyActivate(id));
    }

    async searchAvailableCompanies(body: SearchAvailableAccountCompaniesParameters): Promise<CompanyView[]> {
        return await lastValueFrom(this.client.companySearchAvailableAccountCompanies(body));
    }

    async deactivate(id: number): Promise<void> {
        return await lastValueFrom(this.client.companyDeactivate(id));
    }

    async setAccount(body: SaveAccountParameters): Promise<CompanyView> {
        return await lastValueFrom(this.client.companySetAccount(body));
    }

    async removeAccount(id: number): Promise<void> {
        await lastValueFrom(this.client.companyRemoveAccount(id));
    }
}
